export const NombresRegex = RegExp(/^[A-ZÑ][A-ZÑa-záéíóú'ñ]+(\s[A-ZÑ][A-ZÑa-záéíóú'ñ]+)?$/)
export const DNIRegex = RegExp(/^[0-9]{8}$/)
export const ApellidosRegex = RegExp(/^[A-ZÁÉÍÓÚÑ][a-záéíóú'ñ]+(\s[A-ZÁÉÍÓÚÑ][a-záéíóú'ñ]+)?$/)
export const TelefonoRegex = RegExp(/^[0-9]{0,9}$/)
export const CelularRegex = RegExp(/^(\+[0-9]{2}\s)?[0-9]{3}[\s\-]?[0-9]{3}\s?[0-9]{3,4}$/)
export const CorreoRegex = RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]{3,100}@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,100}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,100}[a-zA-Z0-9])?)*$/)
